module.exports = __webpack_public_path__ + "static/media/LC.907c3ba9.svg";